import ShareableLinkNda from './ShareableLinkNda.component';

export default ShareableLinkNda;